import { useContext, useRef } from 'react'

import { Box, TextField } from '@material-ui/core'
import { CONTENT_TYPES } from '@scoir/college-content'
import ContentModalContext from '../../ContentModalProvider/Context'
import { ERROR_MESSAGES, FIELD_NAMES, LABELS } from '../../components/constants'
import ValidationMessage from '../../components/ValidationMessage'

const VideoLink = () => {
  const { item, onUpdateField, validation, type } = useContext(ContentModalContext)
  const isProgram = type === CONTENT_TYPES.PROGRAMS

  const fieldName = isProgram ? FIELD_NAMES.VIDEO_LINK : FIELD_NAMES.LINK
  const label = isProgram ? LABELS.VIDEO_LINK : LABELS.LINK
  const placeholder = isProgram ? label : LABELS.LINK_PLACEHOLDER
  const id = isProgram ? 'content-item-video-link' : 'content-item-link'
  const helperText = `${!isProgram ? 'Add a website or video URL ' : ''}Youtube and Vimeo links will be watchable.`

  const touchedRef = useRef(false)
  const touched = touchedRef.current
  const value = item[fieldName]
  const hasError = value?.length && !!validation.getHasError(label)

  return (
    <Box>
      <TextField
        id={fieldName}
        fullWidth
        variant="outlined"
        label={label}
        placeholder={placeholder}
        value={value}
        aria-describedby={id}
        helperText={helperText}
        error={hasError}
        onChange={(e) => {
          touchedRef.current = true
          onUpdateField(fieldName, e.target.value)
        }}
      />
      <ValidationMessage
        id={id}
        label={label}
        touched={touched}
        valuesByError={{ [ERROR_MESSAGES.VALID_URL]: value || '' }}
      />
    </Box>
  )
}

export default VideoLink
